<template>
  <div>
    <b-row>
      <b-col>
        <vs-card>
          <div slot="header">
            <h3>Resmi Olmayan Stoklar</h3>
          </div>

          <ag-grid-vue
            style="width: 100%; height: 450px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :localeText="localeText"
            :pagination="true"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </vs-card>
      </b-col>
      <b-col>
        <vs-card>
          <input
            type="file"
            accept="image/*"
            @change="onFileChange"
            id="file-input"
            multiple="multiple"
          />

          <vs-upload
            ref="file"
            automatic
            @on-success="successUpload"
            style="padding: 0"
            @on-change="filechange"
          />
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                color="primary"
                type="gradient"
                icon="done"
                style="border-radius: 5px"
                @click="submitFiles()"
                >Kaydet</vs-button
              >
            </vs-row>
          </div>
        </vs-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import Store from "../../store/store";
import state from "../../store/state";
export default {
  data() {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      rowData: null,
      localeText: null,
    };
  },
  components: {
    AgGridVue,
  },
  methods: {
    filechange() {
      console.log("in");
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    _arrayBufferToBase64(buffer) {
      var binary = "";
      console.log(buffer);
      var bytes = new Uint8Array(buffer.toString());
      console.log(bytes);
      var len = bytes.byteLength;
      console.log(len);
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      console.log(binary);
      return window.btoa(binary);
    },
    submitFiles() {
      let formData = new FormData();
      var deger = [];
      console.log(this.$refs.file);

      for (var i = 0; i < this.$refs.file.filesx.length; i++) {
        let file = this.$refs.file.filesx[i];
        deger.push({ name: file.name, url: this.$refs.file.srcs[i].src });
      }
      if (this.$refs.file.itemRemove.length != 0) {
        this.$refs.file.itemRemove.forEach((val, element) => {
          deger.splice(val, 1);
        });
      }
      console.log(deger);

      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      deger.forEach((val, ind) => {
        //     var srcBase64 = vm._arrayBufferToBase64(val.url);
        console.log(val.url);
        //    const b = Uint8Array.from(atob(val.url), (c) => c.charCodeAt(0));
        //  console.log(b);
        const args = {
          token: Store.state.tokenId,
          fs: val.url,
          dosyaAdi: val.name,
        };
        console.log(args);
        /*   soap.createClient(url, function (err, client) {
          client.INT_Ls_Stock_TopluResim(args, function (err, result) {
            if (result.INT_Ls_Stock_TopluResimResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Ls_Stock_TopluResimResult);

              if (vm.veriler.response == "Ok") {
                vm.rowData = JSON.parse(vm.veriler.jsonData);
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });*/
      });
    },
    onFileChange(e) {
      console.log(e);
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      console.log(file);
      reader.onload = (e) => {
        vm.image = e.target.result;

        // vm.upload(e.target.result, file.name);
        vm.dosyaF = e.target.result;
        console.log(vm.dosyaF);
        // vm.base64ToArrayBuffer(vm.dosyaF);
        console.log(Uint8Array.from(atob(vm.dosyaF), (c) => c.charCodeAt(0)));
        vm.dosyaFName = file.name;
      };
      reader.readAsDataURL(file);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      //  this.rpAcikFaturalarDetay();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getResmiOlmayanStoklar() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };

      soap.createClient(url, function (err, client) {
        client.INT_RESMIOLMAYANSTOKLAR(args, function (err, result) {
          if (result.INT_RESMIOLMAYANSTOKLARResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_RESMIOLMAYANSTOKLARResult);

            if (vm.veriler.response == "Ok") {
              vm.rowData = JSON.parse(vm.veriler.jsonData);
            } else {
              vs.notify({
                title: "Uyarı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: "Liste getirilirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
  },
  created() {
    this.getResmiOlmayanStoklar();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Stok No",
        field: "STOCKNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Stok Adı",
        field: "STOCKNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
  },
};
</script>
<style lang="scss">
.view-upload {
  z-index: 52000000000000000000000000000000000000000000000000000000;
}
.con-input-upload {
  width: 100px;
  height: 100px;
}
.con-img-upload .img-upload {
  width: 100px;
  height: 100px;
}
</style>

